module.exports = __webpack_public_path__ + "img/function.31f0bda9.png";